import React from 'react';
import type { SxProps, Theme } from '@mui/material';
import { HomepageModuleWrapper } from '../homepage-module-wrapper';
import type { IProps } from './ready-to-enroll-inner-component';
import ReadyToEnrollInnerComponent from './ready-to-enroll-inner-component';
import { useGetPageConditionRequirementResults } from '../../../../app/pages-requiring-condition';
import { Page } from '../../../../app/page-url-path';

const ReadyToEnrollModule: React.FC<
IProps & {
  sx?: SxProps<Theme>;
}
> = ({ data, sx }) => {
  const isEnrollmentPageAvailable =
    useGetPageConditionRequirementResults()[Page.ENROLLMENT_PAGE];

  return isEnrollmentPageAvailable ? (
    <HomepageModuleWrapper dataComponentName="ReadyToEnrollModule" sx={sx}>
      <ReadyToEnrollInnerComponent data={data} />
    </HomepageModuleWrapper>
  ) : null;
};

export default ReadyToEnrollModule;
